import CookieItem from './CookieItem';

export default {
  authToken: new CookieItem<string>({ key: 'authToken' }),
  refreshToken: new CookieItem<string>({ key: 'refreshToken' }),
};
